import React, { useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import { Box, Button, TextField } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { addCategory, getCategory } from '../Store/ActionCreators/CategoryActionCreator'

export default function AddCategory() {
  const [data, setData] = useState({
    name:""
  })
  const categoryList = useSelector((state)=>state.CategoryStateData)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  function getData(e){
    const name = e.target.name
    const value = e.target.value
    setData((old)=>{
      return{
        ...old,
        [name] : value
      }
    })
  }
  function postData(e){
    e.preventDefault()
    const newName = data.name.trim().toLowerCase()
  if (!newName) {
    alert("Please Enter Category Name!!!")
    return
  }
  const isExist = categoryList.some(
    item => item.name.trim().toLowerCase() === newName
  )

  if (isExist) {
    alert("This category name already Exists!!!")
    return
  }
    dispatch(addCategory({name:data.name}))
    navigate("/admincategory")
  }
  useEffect(()=>{
    dispatch(getCategory())
  },[])
  return (
    <Box sx={{display:"flex"}}> 
      <Sidebar />
      <Box  className="boxStyle">
        <div className="mt-3" >
          <h4 className='text-light bg-success rounded text-center p-1' style={{
              fontFamily: "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
            }}>Category Form Page
          </h4>
          <div className="formSection">
            <h5>Category From</h5>
            <form className='mt-3' onSubmit={postData}>
              <div className="mb-5">
                <TextField
                label="Category Name *"
                variant="standard"
                placeholder="Enter Category name"
                color="success"
                fullWidth
                name='name'
                onChange={getData}
              />
              </div>
              <Button type='submit' className='bg-success w-100 text-light'>Submit</Button>
          </form>
          </div>
        </div>
      </Box>
    </Box>
  )
}
